// Module: adminOnly.js
// Purpose: The ONE nav-visibility filter for `adminOnly` entries, shared by Sidebar, MoreSheet and NavRail (142-9 R6/A-2).

//! Gateway admin authority is user.is_superuser (role === "admin" is NOT enough).
export const filterAdminOnly = (entries, user) =>
  (entries || []).filter((entry) => !entry.adminOnly || user?.is_superuser === true);
